<template>
    <v-sheet class="header" style="background-color: rgba(206, 220, 236)">
        <div class="prompt-28 text-center pt-9">
            {{ $t('message.formHeader.header')}} {{ openingDate }} - {{ closingDate }}
        </div>
    </v-sheet>
</template>

<script>
import { formatDateTimeLocale } from "@/utils/date";
import i18n from '@/i18n';
export default {
    name: "FormHeader",
    props: {
        openingDateProp: String,
        closingDateProp: String,
    },
    computed: {
        locale() {
            return i18n.locale;
        },
        openingDate() {
            let newDate = Date.parse(this.openingDateProp);
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        closingDate() {
            let newDate = Date.parse(this.closingDateProp);
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
    },
};
</script>
